import { render, staticRenderFns } from "./BillingRatePeriods.vue?vue&type=template&id=571464a4&scoped=true&"
import script from "./BillingRatePeriods.vue?vue&type=script&lang=js&"
export * from "./BillingRatePeriods.vue?vue&type=script&lang=js&"
import style0 from "./BillingRatePeriods.vue?vue&type=style&index=0&id=571464a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571464a4",
  null
  
)

export default component.exports